import { useQuery } from 'react-query'
import { LMSApi } from 'src/api/client'
import {
  FETCH_ALL_LEARNING_MODULES,
  FETCH_LEARNING_MODULE
} from 'src/constants/queries'
import { ILearningModule } from 'src/models/learning'

export const useLearningModules = () => {
  const query = useQuery<ILearningModule[]>(FETCH_ALL_LEARNING_MODULES, () =>
    LMSApi.getLearningModules()
  )

  return { ...query, learningModules: query.data }
}

export const useLearningModule = (id: string) => {
  const query = useQuery<ILearningModule>(
    FETCH_LEARNING_MODULE(id),
    () => LMSApi.getLearningModule(id),
    { enabled: !!id }
  )

  return { ...query, learningModule: query.data }
}
